import OrderHistoryReorderCreateReorder from './orderHistoryReorder/OrderHistoryReorderCreateReorder';
import orderHistoryAddProductsSelectAll from './orderHistoryAddProducts/orderHistoryAddProductsSelectAll';
import OrderHistoryAddProductsValidator from './orderHistoryAddProducts/OrderHistoryAddProductsValidator';
import OrderHistoryAddProductsObservable from './orderHistoryAddProducts/OrderHistoryAddProductsObservable';

if (document.querySelector('[data-id="orderHistoryReorderPage"]')) {
	new OrderHistoryAddProductsObservable();
	const validator = new OrderHistoryAddProductsValidator();
	new OrderHistoryReorderCreateReorder(validator);
	orderHistoryAddProductsSelectAll();
}
